import TelesoftSyncManager from './TelesoftSyncManager.js';

export default class BackofficeProductsForm {

  constructor() {
    this.telesoftSync = new TelesoftSyncManager();
    this.bindEvents();
    this.initTelesoftSyncModal();
  }

  bindEvents() {
    $('.service_id').on('change', this.toggleZoneSelect.bind(this));
    this.toggleZoneSelect();
  }

  toggleZoneSelect() {    
    const selectedOption = $('.service_id option:selected');
    const apiType = selectedOption.data('api-type');

    if (apiType === 'api_type_ftto_tree') {
      $('#zone-select').show();
    } else {
      $('#zone-select').hide();
    }
  }

  initTelesoftSyncModal() {
    const $modal = $('#telesoftSyncModal');
    if (!$modal.length) return;

    // Reset modal state when opened
    $modal.on('show.bs.modal', () => {
      this.resetModalState();
    });

    // Handle confirm button click
    $('#confirm-sync-btn').on('click', () => {
      this.performSyncCheck();
    });

    // Handle update button click
    $('#confirm-update-btn').on('click', () => {
      this.performUpdate();
    });
  }

  resetModalState() {
    // Show initial content
    $('#sync-initial-content').show();
    $('#sync-checking').hide();
    $('#sync-processing').hide();
    $('#sync-updating').hide();
    $('#sync-already-exists').hide();
    $('#sync-success').hide();
    $('#sync-update-success').hide();
    $('#sync-error').hide();
    
    // Show/hide buttons
    $('#confirm-sync-btn').show().prop('disabled', false);
    $('#confirm-update-btn').hide();
    $('#modal-cancel-btn').show();
    $('#modal-close-btn').hide();
  }

  showCheckingState() {
    $('#sync-initial-content').hide();
    $('#sync-checking').show();
    $('#confirm-sync-btn').prop('disabled', true);
  }

  showProcessingState() {
    $('#sync-checking').hide();
    $('#sync-processing').show();
  }

  showUpdatingState() {
    $('#sync-already-exists').hide();
    $('#sync-updating').show();
  }

  showResultState(type, message = '') {
    $('#sync-processing').hide();
    $('#sync-checking').hide();
    $('#sync-updating').hide();
    
    if (type === 'exists') {
      $('#sync-already-exists').show();
      // Show update button and hide sync button
      $('#confirm-sync-btn').hide();
      $('#confirm-update-btn').show();
    } else if (type === 'success') {
      $('#sync-success').show();
      this.hideActionButtons();
    } else if (type === 'update-success') {
      $('#sync-update-success').show();
      this.hideActionButtons();
    } else if (type === 'error') {
      $('#sync-error').show();
      $('#sync-error-message').text(message);
      this.hideActionButtons();
    }
  }

  hideActionButtons() {
    $('#confirm-sync-btn').hide();
    $('#confirm-update-btn').hide();
    $('#modal-cancel-btn').hide();
    $('#modal-close-btn').show();
  }

  performSyncCheck() {
    this.showCheckingState();
    
    const $modal = $('#telesoftSyncModal');
    
    // Use TelesoftSyncManager with modal data attributes
    this.telesoftSync.checkSingleProduct($modal)
    .done((data) => {
      if (data.exists) {
        this.showResultState('exists');
      } else {
        // Product doesn't exist, proceed with sync
        this.performSync();
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error checking product:', error);
      this.showResultState('error', 'Erreur lors de la vérification du produit.');
    });
  }

  performSync() {
    this.showProcessingState();
    
    const $modal = $('#telesoftSyncModal');
    
    // Use TelesoftSyncManager with modal data attributes
    this.telesoftSync.syncSingleProduct($modal)
    .done((data) => {
      if (data.success) {
        this.showResultState('success');
      } else {
        this.showResultState('error', data.error || 'Erreur inconnue lors de la synchronisation.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing:', error);
      this.showResultState('error', 'Erreur lors de la synchronisation avec Telesoft.');
    });
  }

  performUpdate() {
    this.showUpdatingState();
    
    const $modal = $('#telesoftSyncModal');
    
    // Use TelesoftSyncManager with modal data attributes
    this.telesoftSync.updateSingleProduct($modal)
    .done((data) => {
      if (data.success) {
        this.showResultState('update-success');
      } else {
        this.showResultState('error', data.error || 'Erreur inconnue lors de la mise à jour.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error updating:', error);
      this.showResultState('error', 'Erreur lors de la mise à jour dans Telesoft.');
    });
  }

  onDataChanged(data) {

  }

  onDestroy() {
    // Clean up event listeners if needed
    $('#telesoftSyncModal').off('show.bs.modal');
    $('#confirm-sync-btn').off('click');
    $('#confirm-update-btn').off('click');
  }
}